module.exports = __webpack_public_path__ + "cbd3f274eaf55565f3015e3e6b9a9479.svg";